import React, { useState } from 'react';
import { Labels } from '../../../style';
import { Button, Icon } from 'react-materialize';
import { FaBroom } from 'react-icons/fa';

export function ComponentSearch({ productsFilter, handleSearchProduct, cleanForm }) {
  const [searchProduct, setSearchProduct] = useState('');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', marginTop: '5px', width: '100%' }}>
      <Labels>Buscar produto</Labels>
      <input
        type="text"
        value={searchProduct}
        onChange={(event) => setSearchProduct(event.target.value)}
        onKeyUp={(event) => {
          if (event.key === 'Enter') {
            handleSearchProduct(searchProduct);
          }
        }}
      />
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
        <Button
          style={{ width: '100%' }}
          onClick={() => handleSearchProduct(searchProduct)}
          className="waves-effect waves-light saib-button is-primary"
        >
          <Icon className="modal-close">search</Icon>
          Pesquisar
        </Button>
        <Button
          disabled={productsFilter.length === 0}
          style={{ width: '100%' }}
          onClick={cleanForm}
          className="waves-effect waves-light saib-button is-primary"
        >
          <FaBroom size={18} style={{ marginRight: '0.5rem' }} />
          Limpar dados
        </Button>
      </div>
    </div>
  );
}
